import React, { memo, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './ResidualSoftList.module.less';
import ResidualSoft from './ResidualSoft';
import { getResidualMixBatchDetails } from '../../actions/uninstall';

const selectResidualList = createSelector(
  state => state.uninstall,
  uninstall => uninstall.residualList,
);
const selectTempResidualList = createSelector(
  state => state.uninstall,
  uninstall => uninstall.tempResidualList,
);
const selectResidualDetail = createSelector(
  state => state.uninstall,
  uninstall => {
    return uninstall.residualDetail;
  },
);
export default memo(({ activeCategory, mixBatchDetails }) => {
  const residualList = useSelector(selectResidualList);
  const tempResidualList = useSelector(selectTempResidualList);
  const [residualIcon, setResidualIcon] = useState({}); // 存储残留文件的icon
  const residualIconRef = useRef();
  const residualDetail = useSelector(selectResidualDetail);
  useEffect(() => {
    residualIconRef.current = residualIcon;
  });
  const dispatch = useDispatch();
  useEffect(() => {
    const obj = {};
    [...mixBatchDetails, ...residualDetail].forEach(item => {
      if (!residualIconRef.current[item.softID]) {
        obj[item.softID] = item.logoFile;
      }
    });
    setResidualIcon({ ...residualIconRef.current, ...obj });
  }, [residualDetail, mixBatchDetails]);
  useEffect(() => {
    const list = residualList;
    if (!residualList || residualList.length < 1) {
      return;
    }
    const softIdList = list.map(item => item.SoftID).filter(item => item);
    if (softIdList && softIdList.length > 0) {
      dispatch(
        getResidualMixBatchDetails({
          params: {
            softIds: softIdList,
          },
        }),
      );
    }
  }, [residualList]);

  return (
    <>
      {activeCategory === 'residual' &&
        tempResidualList &&
        tempResidualList.map((soft, index) => {
          return (
            <div className={styles.line_soft} key={`${index}_${soft.softGUID}temp`}>
              <ResidualSoft
                residualInfo={{
                  ...soft,
                  logoFile:
                    soft.SoftID || soft.softid
                      ? residualIcon[soft.SoftID || soft.softid]
                      : soft.logoFile,
                }}
                soft={{
                  ...soft,
                  logoFile:
                    soft.SoftID || soft.softid
                      ? residualIcon[soft.SoftID || soft.softid]
                      : soft.logoFile,
                }}
              />
            </div>
          );
        })}
      {(activeCategory === 'residual' || activeCategory === 'all_zw') &&
        residualList &&
        residualList.map((soft, index) => {
          return (
            <div className={styles.line_soft} key={`${index}_${soft.softGUID}`}>
              <ResidualSoft
                residualInfo={{
                  ...soft,
                  logoFile: soft.SoftID ? residualIcon[soft.SoftID] : soft.logoFile,
                }}
                soft={{
                  ...soft,
                  logoFile: soft.SoftID ? residualIcon[soft.SoftID] : soft.logoFile,
                }}
              />
            </div>
          );
        })}
    </>
  );
});
